<template>
    <span class="ah-rich-pop-info">
        <el-popover v-model="show" placement="top" :width="width" trigger="hover" popper-class="ah-rich-pop-info_el-popover">
            <div class="ah-rich-pop-info_wrapper">
                <slot name="info">
                    <div v-if="img" class="image-rect">
                        <img class="image" :src="img" :alt="title" />
                    </div>
                    <div class="default-content">
                        <div v-if="title" class="title">{{ title }}</div>
                        <slot name="content">
                            <div v-if="content" class="content">{{ content }}</div>
                        </slot>
                    </div>
                </slot>
            </div>
            <span slot="reference"><slot /></span>
        </el-popover>
    </span>
</template>
<script>
export default {
    props: {
        width: {
            type: Number,
            default: 250,
        },
        title: {
            type: String,
            default: null,
        },
        content: {
            type: String,
            default: null,
        },
        img: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            show: false,
        };
    },
};
</script>
<style lang="scss">
.ah-rich-pop-info {
    .tip {
        border-bottom: 2px dotted #ccc;
        padding-bottom: 2px;
        cursor: default;
    }
}
.el-popover.ah-rich-pop-info_el-popover {
    background-color: #4a4294;
    color: #fff;
    text-align: center;
    border: none;
    box-shadow: 0 10px 12px 0 rgba(0, 0, 0, 0.25);

    .popper__arrow::after {
        border-top-color: #4a4294 !important;
    }

    .ah-rich-pop-info_wrapper {
        min-height: 100px;

        > .image-rect {
            img {
                display: block;
                width: 100%;
                border-radius: 5px;
            }
        }

        > .default-content {
            display: grid;
            grid-template-columns: 1fr;
            gap: 15px;
            padding: 16px;

            > .title {
                font-size: 12pt;
                font-weight: bold;
            }
            > .content {
                width: 96%;
                margin: 0 auto;
                font-size: 10pt;
                text-align: left;
            }
        }
    }
}
</style>
